import type { Event } from '@models/Event'

import { apiClient } from '../../../gateways/api'

export { fetchProjectLog }

const fetchProjectLog = async ({ id }: { id?: string }): Promise<Event[]> => {
  const { data } = await apiClient({
    url: `/rest/project/${id}/event`,
    method: 'GET',
  })

  return data
}
